export const search = {
  Artists: 'Artists',
  'Artists/Composers': 'Artists/Composers',
  Songs: 'Songs',
  Playlists: 'Playlists',
  Works: 'Works',
  'Top Result': 'Top Result',
  'No results': 'No results',
  'No results where found for': 'No results where found for',
};
